import { useTranslation } from 'react-i18next';

import { accuracyColor, DataPanelItem, DataPanelRow } from '@/ui';
import type { PortalLocationMeasured } from '@/signalr';
import { formatAccuracy, formatPortalAltitude } from '@ngsos/portal-core/incidents';

export type PositionInfoPanelRowProps = {
  lastIncidentPosition: PortalLocationMeasured;
};

export function PositionInfoPanelRow({ lastIncidentPosition }: PositionInfoPanelRowProps) {
  const { t, i18n } = useTranslation();
  const language = i18n.language || 'en';

  return (
    <DataPanelRow>
      <DataPanelItem
        title={t('Incident_InfoPanel_Accuracy')}
        value={
          lastIncidentPosition.accuracy === null ? undefined : formatAccuracy(lastIncidentPosition.accuracy, language)
        }
        color={lastIncidentPosition.accuracy === null ? 'none' : accuracyColor(lastIncidentPosition.accuracy)}
        showEmptyPlaceholder
      />

      <DataPanelItem
        title={t('Incident_InfoPanel_Altitude')}
        value={formatPortalAltitude(lastIncidentPosition, language)}
        contentCssClass="text-end"
        showEmptyPlaceholder
      />
    </DataPanelRow>
  );
}
